module.exports = __webpack_public_path__ + "img/dmcr.281c46a8.png";